export const passwordValidate = (password) => {
  const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,100}$/;
  const check = password?.match(re);
  if (check !== null) return true;
  return false;
};
